import { render, staticRenderFns } from "./userRankList.vue?vue&type=template&id=3dbd2208"
import script from "./userRankList.vue?vue&type=script&lang=js"
export * from "./userRankList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports